angular.module( 'mx.components', []);
angular.module('mx.directives', []);
angular.module('mx.filters', []);
angular.module( 'mx.services', []);

;// end of file;